import { motion, MotionProps } from 'framer-motion'
import { variants, variantsType } from '../../styles/animation'

interface Props extends MotionProps {
   children: React.ReactNode
   animate: variantsType
   exit?: variantsType
   initial?: variantsType
   className?: string
   onClick?: () => void
}

const AnimateWithVariants: React.FC<Props> = (props) => {
   return (
      <motion.div {...props} variants={variants} className={props.className}>
         {props.children}
      </motion.div>
   )
}

export default AnimateWithVariants
